<router-outlet />

<app-toaster />

<app-global-modal />

@if (!!(jwtState$ | async)) {
  <wiz-sidebar class="wiz-sidebar" [environment]="platform" />
}
